import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { bool, string, number } from 'prop-types';
import { Copy } from '@magalu/stereo-ui-icons';
import { StyledInput, StyledButton } from './copy-to-clipboard.styles';
import Flex from '../../atoms/Flex';
import { copyToClipboard } from '../../utils';

function CopyToClipboard(_ref) {
  let {
    value
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["value"]);

  const {
    color,
    'data-testid': dataTestId,
    disabled,
    uppercase,
    variation,
    delay
  } = props,
        inputProps = _objectWithoutPropertiesLoose(props, ["color", "data-testid", "disabled", "uppercase", "variation", "delay"]);

  const [isActive, setIsActive] = useState(false);
  const [isDisabled, setIsDisabled] = useState(disabled);

  const handleCopyToClipboard = link => {
    setIsActive(true);
    setIsDisabled(true);
    copyToClipboard(link);
    return setTimeout(() => {
      setIsActive(false);
      setIsDisabled(false);
    }, delay);
  };

  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(StyledInput, _extends({
    "data-testid": `${dataTestId}-input`,
    readOnly: true,
    value: value
  }, inputProps)), /*#__PURE__*/React.createElement(StyledButton, {
    color: color,
    "data-testid": `${dataTestId}-button`,
    disabled: isDisabled,
    onClick: () => handleCopyToClipboard(value),
    startIcon: /*#__PURE__*/React.createElement(Copy, {
      width: 25,
      height: 21
    }),
    uppercase: uppercase,
    variation: variation
  }, isActive ? 'Copiado' : 'Copiar'));
}

CopyToClipboard.defaultProps = {
  color: 'primary',
  'data-testid': 'copy-to-clipboard',
  delay: 3000,
  disabled: false,
  uppercase: false,
  value: '',
  variation: 'fill'
};
process.env.NODE_ENV !== "production" ? CopyToClipboard.propTypes = {
  color: string,
  'data-testid': string,
  delay: number,
  disabled: bool,
  uppercase: bool,
  value: string,
  variation: string
} : void 0;
CopyToClipboard.displayName = 'CopyToClipboard';
export default CopyToClipboard;